import React, { useEffect, useState } from "react";
import AppShell from "../components/AppShell";
import api from "../lib/api";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { AddToMealLogButton } from "../components/AddToMealLogButton";

const CAT_LABEL = { desayuno: "Desayunos", almuerzo: "Almuerzos", cena: "Cenas" };

export default function Meals() {
  const [meals, setMeals] = useState([]);
  useEffect(() => { api.get("/content/meals").then((r) => setMeals(r.data)); }, []);

  const groups = ["desayuno", "almuerzo", "cena"];

  return (
    <AppShell title="30 comidas saludables" subtitle="Altas en proteína, bajas en azúcar y fáciles de preparar.">
      <Tabs defaultValue="desayuno">
        <TabsList className="bg-[var(--mep-surface)] border border-[var(--mep-border)]">
          {groups.map((g) => (
            <TabsTrigger
              key={g}
              value={g}
              data-testid={`meals-tab-${g}`}
              className="data-[state=active]:bg-[var(--mep-pink)] data-[state=active]:text-white"
            >
              {CAT_LABEL[g]}
            </TabsTrigger>
          ))}
        </TabsList>
        {groups.map((g) => (
          <TabsContent key={g} value={g}>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-6">
              {meals.filter((m) => m.category === g).map((m) => (
                <article key={m.id} className="mep-card overflow-hidden flex flex-col">
                  <div className="aspect-[4/3] overflow-hidden">
                    <img src={m.image} alt={m.name} className="w-full h-full object-cover" />
                  </div>
                  <div className="p-5 flex-1 flex flex-col">
                    <h3 className="font-display text-lg font-medium tracking-tight">{m.name}</h3>
                    <div className="flex gap-2 mt-3 text-xs">
                      <span className="mep-pill-pink !text-[10px] !py-1 !px-2">{m.protein_g} g proteína</span>
                      <span className="mep-pill-gold !text-[10px] !py-1 !px-2">{m.calories} kcal</span>
                    </div>
                    <div className="mt-4 text-eyebrow">Ingredientes</div>
                    <ul className="text-sm text-[var(--mep-text-muted)] mt-2 space-y-1">
                      {m.ingredients.map((i, idx) => <li key={idx}>· {i}</li>)}
                    </ul>
                    <div className="mt-4 text-eyebrow">Preparación</div>
                    <p className="text-sm mt-2">{m.prep}</p>
                    <AddToMealLogButton item={{ ...m, kcal: m.calories }} defaultMealType={m.category} />
                  </div>
                </article>
              ))}
            </div>
          </TabsContent>
        ))}
      </Tabs>
    </AppShell>
  );
}
